import React from 'react';
import { Link } from 'react-router-dom';

const RepairsService = () => {
    return (
        <div className="content">
            <div className="col-12">
                <div className="header-container mb-3">
                    <div className="header"><h1>Товари відсутні</h1></div>
                    <div className="header-functions">
                        <div className="float-end mx-2">
                            <Link className='btn btn-primary'>
                                Друк звіту
                            </Link>
                        </div>
                        <div className="float-end  mx-2">
                            <div className="input-group">
                                <input type="text" className="form-control" placeholder="Пошук..." aria-label="Recipient's username" aria-describedby="button-addon2" />
                                <button className="btn btn-outline-secondary" type="button" id="button-addon2"><i className="bi bi-search"></i></button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <a href="/repairs_service" className="btn btn-info no-print mb-3 mx-1" >Всі</a>
                        <a href="/repairs_service?owner_id=136" className="btn btn-primary no-print mb-3 mx-1" >Владислав Данильчук (0)</a>
                        <a href="/repairs_service?owner_id=100" className="btn btn-primary no-print mb-3 mx-1" >Степан Мякота (0)</a>
                        <a href="/repairs_service?owner_id=80" className="btn btn-primary no-print mb-3 mx-1" >Кузнєцов Артур (0)</a>
                        <div className="alert alert-warning">
                            Товари відсутні
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RepairsService;